import styles from '../index.module.less'
import { Card } from '@modules/missions/keaz/step/components/card'
import { PhotoView } from '@modules/missions/keaz/step/components/photoView'
import { FormGroup } from '@modules/missions/keaz/step/components/formGroup'
import { Checkbox } from '@smwb/summer-ui/dist/connects/rff'
import {
  MechanicalStepInjectionUnitLeakCheck,
  MechanicalStepInjectionUnitLeakCheckFields
} from '@modules/missions/keaz/types'
import { DeviationsFormFields } from '@modules/missions/keaz/step/components/contentBySteps/components/deviationsFormFields'
import React from 'react'
import { StepForm } from '@modules/missions/keaz/step/components/stepForm'

import { ErrorMessage } from '@modules/missions/keaz/step/components/contentBySteps/components/errorMessage'

export interface InjectionUnitLeakCheckProps {
  compact: boolean
  step: MechanicalStepInjectionUnitLeakCheck
  isEditableStep: boolean
  setCompact: React.Dispatch<React.SetStateAction<boolean>>
  onBackClick: () => void
  refetchReports: () => void
}

export function InjectionUnitLeakCheck({
  compact,
  step,
  isEditableStep,
  setCompact,
  onBackClick,
  refetchReports
}: InjectionUnitLeakCheckProps) {
  return (
    <div>
      <StepForm<MechanicalStepInjectionUnitLeakCheck>
        step={step}
        compact={compact}
        isEditableStep={isEditableStep}
        setCompact={setCompact}
        onBackClick={onBackClick}
        refetchReports={refetchReports}
      >
        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <Checkbox
              name={MechanicalStepInjectionUnitLeakCheckFields.injectionUnitLeakCheck}
              label='Проверка на течь масла цилиндров узлов впрыска проведена'
              disabled={compact}
            />

            <ErrorMessage
              fieldName={MechanicalStepInjectionUnitLeakCheckFields.injectionUnitLeakCheck}
              className={styles.errorMessage}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepInjectionUnitLeakCheck>
              compact={compact}
              title='Фото цилиндров узлов впрыска'
              fieldName={MechanicalStepInjectionUnitLeakCheckFields.injectionUnitCylindersPhoto}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<MechanicalStepInjectionUnitLeakCheck>
              compact={compact}
              title='Фото цилиндров узлов впрыска после замены уплотнений'
              fieldName={MechanicalStepInjectionUnitLeakCheckFields.injectionUnitSealsReplacedPhoto}
            />
          </Card>
        </FormGroup>

        <DeviationsFormFields
          compact={compact}
          detectedFieldName={MechanicalStepInjectionUnitLeakCheckFields.deviations}
          commentFieldName={MechanicalStepInjectionUnitLeakCheckFields.deviationsComment}
          className={styles.deviationsFields}
        />
      </StepForm>
    </div>
  )
}
